<div *transloco="let t">
  <app-main-header>{{ t('account-settings') }}</app-main-header>
  <app-account-settings-tab-group></app-account-settings-tab-group>
</div>
